module.exports = __webpack_public_path__ + "img/atari1200_page16.5976ab7e.jpg";